import { render, staticRenderFns } from "./LmDocumentPreview.vue?vue&type=template&id=196b6c97&scoped=true"
import script from "./LmDocumentPreview.vue?vue&type=script&lang=js"
export * from "./LmDocumentPreview.vue?vue&type=script&lang=js"
import style0 from "./LmDocumentPreview.vue?vue&type=style&index=0&id=196b6c97&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196b6c97",
  null
  
)

export default component.exports